import api from '../../api';
import { push } from 'connected-react-router';
import { store as storeNotification } from 'react-notifications-component';
import { socket } from '../store/socket';

const notificationConfig = {
  container: 'top-center',
  animationIn: ['animated', 'fadeIn'],
  animationOut: ['animated', 'fadeOut'],
  dismiss: {
    duration: 1500,
    showIcon: true
  }
};

export const codesNCMStartRequest = () => {
  return {
    type: 'CODES_NCM_START_REQUEST'
  };
};

export const codesNCMEndRequest = () => {
  return {
    type: 'CODES_NCM_END_REQUEST'
  };
};

export const getAllCodesNCMSuccess = ({ data }) => {
  return {
    type: 'CODES_NCM_GET_ALL_SUCCESS',
    payload: data
  };
};

export const getAllCodesNCMError = error => {
  return {
    type: 'CODES_NCM_GET_ALL_ERROR',
    payload: error
  };
};

export const addCodesNCMSuccess = ({ data }) => {
  return {
    type: 'CODES_NCM_ADD_SUCCESS',
    payload: data
  };
};

export const addCodesNCMError = error => {
  return {
    type: 'CODES_NCM_ADD_ERROR',
    payload: error
  };
};

export const editCodesNCMSuccess = ({ data }) => {
  return {
    type: 'CODES_NCM_EDIT_SUCCESS',
    payload: data
  };
};

export const editCodesNCMError = error => {
  return {
    type: 'CODES_NCM_EDIT_ERROR',
    payload: error
  };
};

export const removeCodesNCMSuccess = id => {
  return {
    type: 'CODES_NCM_REMOVE_SUCCESS',
    payload: id
  };
};

export const removeCodesNCMError = error => {
  return {
    type: 'CODES_NCM_REMOVE_ERROR',
    payload: error
  };
};

export const codesNCMModifyStore = ({ data }) => {
  return {
    type: 'CODES_NCM_MODIFY_STORE',
    payload: data
  };
};

export const addCodesNCM = (data, formReset, submitBtn) => {
  return async dispatch => {
    try {
      submitBtn.disabled = true;
      dispatch(codesNCMStartRequest());
      const response = await api().post('/api/codes_ncm', data);
      dispatch(addCodesNCMSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'ADD',
        module: 'codesNCM',
        data: [response.data]
      });
      formReset();
    } catch (err) {
      dispatch(addCodesNCMError(err));
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      setTimeout(() => {
        dispatch(codesNCMEndRequest());
        submitBtn.disabled = false;
      }, 1800);
    }
  };
};

export const getAllCodesNCM = (params = {}) => {
  return async dispatch => {
    try {
      dispatch(codesNCMStartRequest());
      const response = await api().get('/api/codes_ncm', { params });
      dispatch(getAllCodesNCMSuccess(response));
    } catch (err) {
      dispatch(getAllCodesNCMError(err));
    } finally {
      dispatch(codesNCMEndRequest());
    }
  };
};

export const editCodesNCM = (data, submitBtn = {}, handleModalClose) => {
  return async dispatch => {
    const defaultMsg = button => {
      return new Promise(resolve => {
        document
          .getElementsByClassName('page-content')[0]
          .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        setTimeout(() => {
          dispatch(codesNCMEndRequest());
          button.disabled = false;
          resolve(true);
        }, 1800);
      });
    };

    try {
      submitBtn.disabled = true;
      dispatch(codesNCMStartRequest());
      const id = data._id;
      const response = await api().put('/api/codes_ncm/' + id, data);
      dispatch(editCodesNCMSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'EDIT',
        module: 'codesNCM',
        data: [response.data]
      });
      await defaultMsg(submitBtn);
      if (handleModalClose) {
        handleModalClose();
      } else {
        dispatch(push('/codes_ncm'));
      }
    } catch (err) {
      dispatch(editCodesNCMError(err));
      await defaultMsg(submitBtn);
    }
  };
};

export const removeCodesNCM = id => {
  return async dispatch => {
    try {
      dispatch(codesNCMStartRequest());
      await api().delete('/api/codes_ncm/' + id);
      dispatch(removeCodesNCMSuccess(id));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'REMOVE',
        module: 'codesNCM',
        data: id
      });
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Código NCM removido com sucesso.',
          type: 'success'
        });
      }, 300);
    } catch (err) {
      dispatch(removeCodesNCMError(err));
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Falha ao remover código NCM.',
          type: 'danger'
        });
      }, 300);
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      dispatch(codesNCMEndRequest());
    }
  };
};

export const restoreCodesNCM = data => {
  return async dispatch => {
    try {
      dispatch(codesNCMStartRequest());
      const id = data._id;
      const response = await api().put('/api/codes_ncm/' + id, data);
      dispatch(editCodesNCMSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'RESTORE',
        module: 'codesNCM',
        data: [response.data]
      });
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Código NCM restaurado com sucesso.',
          type: 'success'
        });
      }, 300);
    } catch (err) {
      dispatch(editCodesNCMError(err));
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Falha ao restaurar código NCM.',
          type: 'danger'
        });
      }, 300);
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      dispatch(codesNCMEndRequest());
    }
  };
};
